import Environment from "./environment.type";

export const environment: Environment = {
    tenantSlug: 'stuettem',
    sentryEnvironment: 'production',
};
